import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCodex = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 33,
	height: 33,
	fill: "none",
	viewBox: "0 0 33 33",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 33,
		height: 33,
		fill: "#94A8E3",
		rx: 5
	}), /* @__PURE__ */ _jsx("path", {
		stroke: "#FBFBFB",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.575,
		d: "m10.281 22.433 5.972-5.972-5.972-5.972M18.244 24.424h7.962"
	})]
});
export default SvgCodex;
